var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 31C0.799805 13.8792 14.679 0 31.7998 0C48.9206 0 62.7998 13.8792 62.7998 31C62.7998 48.1208 48.9206 62 31.7998 62C14.679 62 0.799805 48.1208 0.799805 31Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0498 37.6663V24.3329C23.0498 23.2335 23.0498 22.6838 23.2812 22.3585C23.4831 22.0745 23.7943 21.8878 24.1399 21.8433C24.5354 21.7922 25.0195 22.0504 25.9877 22.5668L25.9905 22.5683L38.4905 29.2349C39.5648 29.8079 40.102 30.0945 40.278 30.476C40.4314 30.8083 40.4314 31.191 40.278 31.5233C40.102 31.9048 39.5648 32.1914 38.4905 32.7643L25.9905 39.431L25.987 39.4328C25.0192 39.949 24.5353 40.2071 24.1399 40.1561C23.7943 40.1115 23.4831 39.9248 23.2812 39.6409C23.0498 39.3156 23.0498 38.7657 23.0498 37.6663Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.853352765006b9b4d90dfadbeb645cbc.svg";
export { ForwardRef as ReactComponent };